import { VcsIntegration } from "types/generated";

export const getVCSIntegrationId = (integration: VcsIntegration) =>
  `${integration.provider}-${integration.id}`;
